/// <amd-module name="typeahead/core/message/InputClearedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class InputClearedMessage implements TypeaheadMessage {

    /* 2017-05-18: This string should match the value published in uitoolkit in uitk_formutils.js */
    public static getTopic(): string {
        return "Input cleared";
    }

    public $elem: JQuery;

    constructor($elem: JQuery) {
        this.$elem = $elem;
    }

    public getTopic(): string {
        return InputClearedMessage.getTopic();
    }
}
